export default "__VITE_ASSET__DOIEO4sQ__"